import Icon from '../../components/Icon.vue'

Icon.register({"brands/tumblr-square":{"width":448,"height":512,"paths":[{"d":"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM317.7 396.2C309.2 405.3 286.5 416 256.8 416 181.3 416 164.9 360.5 164.9 328.1V238.1H135.2C131.8 238.1 129 235.3 129 231.9V189.4C129 184.9 131.8 180.9 136.1 179.4 174.9 165.7 187 131.9 188.8 106.2 189.3 99.3 192.9 96 198.8 96H243.1C246.5 96 249.3 98.8 249.3 102.2V174.2H301.2C304.6 174.2 307.4 177 307.4 180.4V231.5C307.4 234.9 304.6 237.7 301.2 237.7H249.1V321C249.1 342.4 263.9 354.5 291.6 343.4 294.6 342.2 297.2 341.4 299.6 342 301.8 342.5 303.2 344.1 304.2 346.9L318 387.1C319 390.3 320 393.8 317.7 396.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/tumblr-square.js
// module id = 0jol
// module chunks = 0